
<div *ngIf="!isLoading"><router-outlet></router-outlet></div>

<div *ngIf="isLoading" id="nb-global-spinner" class="spinner">
<h1>Loading...</h1>
</div>